import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import TableChartIcon from '@material-ui/icons/TableChart';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import {
  vacationHourFileUpload,
  userHoursUpdate,
} from '../../../../redux/vacationHours/vacationHourActions';
import {
  makeStyles,
  withStyles,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from '@material-ui/core';
import mainLogo from '../../../../assets/tenor.gif';

import FileDropzoneArea from './UploadFile';
import VacationHourTable from './VacationHourTable';

const columns = [
  { id: 'empId', label: 'Employee Id' },
  { id: 'empFName', label: 'Name' },
  { id: 'empEmail', label: 'EmailId' },
  { id: 'vacationHrs', label: 'Vacation Hours' },
  { id: 'sickHrs', label: 'Sick Hours' },
  { id: 'holidayHrs', label: 'Holiday Hours' },
];

const ColorLibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorLibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorLibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <CloudUploadIcon />,
    2: <TableChartIcon />,
    3: <AssignmentTurnedInIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const getSteps = () => ['File upload', 'Hours List', 'Finish'];

const TimesheetVocationHours = props => {
  document.title = 'Sciata Vacation Hours';

  const [file, setFile] = useState(undefined);
  const onFileUpload = file => {
    setFile(file);
  };
  const nbStyle = {
    logo: {
      width: 'auto',
    },
  };
  const getStepContent = step => {
    switch (step) {
      case 0:
        return <FileDropzoneArea file={file} onFileUpload={onFileUpload} />;
      case 1:
        return (
          <VacationHourTable
            {...userTableProps}
            showUploadButton={false}
            gotoUpload={() => {
              props.history.push('/admin/uploadVacationHrs');
            }}
          />
        );
      case 2:
        return (
          <div style={{ width: '400px' }}>
            <img src={mainLogo} style={nbStyle.logo} alt='success' />
          </div>
        );
      default:
        return 'Nothing';
    }
  };

  const classes = useStyles();
  const dispatch = useDispatch();
  const vacationHour = useSelector(state => state.vacationHour.vacationHourList || []);
  const [rows, setRows] = useState([]);
  const [orderAscending, setOrderAscending] = useState(true);
  const [asc, setAsc] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeStep, setActiveStep] = React.useState(0);
  const [activeRecords, setActiveRecords] = useState(true);
  const steps = getSteps();

  const handleNext = () => {
    if (activeStep === 0) {
      dispatch(vacationHourFileUpload(file));
    }
    if (activeStep === 1) {
      dispatch(userHoursUpdate(vacationHour));
    }
    if (activeStep === 2) {
      props.history.push('/admin/vacationHoursList');
    }
    if (file) {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };
  const handleBack = () => {
    setFile(undefined);
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  useEffect(() => {
    setRows(
      vacationHour.map(item => {
        return { ...item, isEdit: false };
      })
    );
  }, [vacationHour]);

  const sortArray = (arr, property) => () => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }
    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const userTableProps = {
    columns,
    rows,
    sortArray,
    orderAscending,
    asc,
    activeRecords,
    searchTerm,
    ...props,
  };
  return (
    <>
      <h1>Holiday / Vacation / Sick Hours</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid item md={12} sm={12}>
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorLibConnector />}
          >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            <Typography className={classes.instructions}>
              <div className={classes.root}>{getStepContent(activeStep)}</div>
            </Typography>
            <div>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                className={classes.button}
              >
                Back
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={handleNext}
                className={classes.button}
                disabled={!file}
              >
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default withRouter(TimesheetVocationHours);
